<template>
  <div class="form-info">
    <slot></slot>
  </div>
</template>

 <script>
  export default {
    name: 'form-info'
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .form-info {
    border: 1px solid var(--gray-200);
    padding: 16px;
    border-radius: 8px;
    background: var(--gray-100);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: .5s $transition-default;
    transition-property: height, background-color, border-color;
    will-change: height, background-color, border-color;

    .field-holder:first-child {
      margin-top: 0;
      text-align: center;
    }

    &.error {
      background-color: fade-out($color-red, .7);
      border-color: $color-red;
    }
  }
</style>
